module.exports = __webpack_public_path__ + "e563fb41f639bbb870fb4027e2ce8e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cypher3.png
// module id = 1029
// module chunks = 0